module.exports = __webpack_public_path__ + "static/virtual-45474a7536ee2bedaf13cea7ec8965e9.svg";